import { SIZE as BTN_SIZE, Button, KIND } from 'baseui/button';
import { HeadingLarge, LabelMedium, ParagraphMedium } from 'baseui/typography';
import { Block } from 'baseui/block';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';
import { useIsDark } from '../contexts/ThemeContext';

interface ContactLink {
  labelKey: string;
  href: string;
  description: string;
  actionKey: string;
}

const LINKS: ContactLink[] = [
  { labelKey: 'contact.linkedin', href: 'https://www.linkedin.com/in/matthew-bluestein', description: 'linkedin.com/in/matthew-bluestein', actionKey: 'contact.visit' },
  { labelKey: 'contact.email', href: 'mailto:job@matthewbluestein.com', description: 'job@matthewbluestein.com', actionKey: 'contact.sendEmail' },
  { labelKey: 'contact.github', href: 'https://github.com/Matt-Blue', description: 'github.com/Matt-Blue', actionKey: 'contact.visit' },
];

export default function Contact() {
  const [, theme] = useStyletron();
  const { t } = useTranslation();
  const isDark = useIsDark();

  const cardBackground = isDark ? 'rgba(0,0,0,0.15)' : 'rgba(255,255,255,0.2)';
  const cardBorder = isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(255,255,255,0.4)';

  return (
    <Block>
      <HeadingLarge marginBottom="scale600">{t('contact.heading')}</HeadingLarge>
      <ParagraphMedium marginBottom="scale900">
        {t('contact.intro')}
      </ParagraphMedium>

      <Block display="flex" flexDirection="column" gridGap="scale600">
        {LINKS.map((link) => (
          <Block
            key={link.labelKey}
            display="flex"
            alignItems="center"
            gridGap="scale600"
            padding="scale600"
            overrides={{
              Block: {
                style: {
                  background: cardBackground,
                  backdropFilter: 'blur(8px)',
                  WebkitBackdropFilter: 'blur(8px)',
                  border: cardBorder,
                  borderRadius: theme.borders.radius300,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
                },
              },
            }}
          >
            <Block flex="1">
              <LabelMedium marginBottom="scale100">{t(link.labelKey)}</LabelMedium>
              <ParagraphMedium color="contentSecondary" marginTop="0" marginBottom="0">
                {link.description}
              </ParagraphMedium>
            </Block>
            <Button
              kind={KIND.primary}
              size={BTN_SIZE.compact}
              $as="a"
              href={link.href}
              target={link.href.startsWith('mailto') ? undefined : '_blank'}
              rel="noopener noreferrer"
            >
              {t(link.actionKey)}
            </Button>
          </Block>
        ))}
      </Block>
    </Block>
  );
}
